// Sample ICS data for testing when external fetch fails
export const labRetreatIcsData = `BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//Lab Retreat Schedule//EN
CALSCALE:GREGORIAN
METHOD:PUBLISH
BEGIN:VTIMEZONE
TZID:Europe/Zurich
X-LIC-LOCATION:Europe/Zurich
BEGIN:DAYLIGHT
TZOFFSETFROM:+0100
TZOFFSETTO:+0200
TZNAME:CEST
DTSTART:19700329T020000
RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU
END:DAYLIGHT
BEGIN:STANDARD
TZOFFSETFROM:+0200
TZOFFSETTO:+0100
TZNAME:CET
DTSTART:19701025T030000
RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU
END:STANDARD
END:VTIMEZONE
BEGIN:VEVENT
UID:ba49a316-65f8-4095-9f8c-e889237502ad
DTSTAMP:20250610T061337Z
SUMMARY:Leaving from Zurich HB
DTSTART;TZID=Europe/Zurich:20250612T070700
DTEND;TZID=Europe/Zurich:20250612T085100
DESCRIPTION:Meeting point 10 min before at platform; group reservation for carriage.
LOCATION:Zurich HB
END:VEVENT
BEGIN:VEVENT
UID:e618aee4-6fbf-43b7-af79-dcf264d29c5a
DTSTAMP:20250610T061337Z
SUMMARY:Arriving in Churwalden
DTSTART;TZID=Europe/Zurich:20250612T085100
DTEND;TZID=Europe/Zurich:20250612T085600
DESCRIPTION:
LOCATION:Churwalden, Bergbahnen (5 min walk to Hotel Krone)
END:VEVENT
BEGIN:VEVENT
UID:48b07f39-464c-45e9-a926-13bc03a590e8
DTSTAMP:20250610T061337Z
SUMMARY:Arrival & Setup
DTSTART;TZID=Europe/Zurich:20250612T090000
DTEND;TZID=Europe/Zurich:20250612T091500
DESCRIPTION:Leaving luggage in storage room.
LOCATION:Hotel Krone
END:VEVENT
BEGIN:VEVENT
UID:e51036c1-169a-44dd-b67c-7f360201c9be
DTSTAMP:20250610T061337Z
SUMMARY:Welcome & Program Overview
DTSTART;TZID=Europe/Zurich:20250612T091500
DTEND;TZID=Europe/Zurich:20250612T093000
DESCRIPTION:
LOCATION:Menna
END:VEVENT
BEGIN:VEVENT
UID:b9205f75-b8ca-4c85-9920-6633e002ff2f
DTSTAMP:20250610T061337Z
SUMMARY:Raph PhD Outline
DTSTART;TZID=Europe/Zurich:20250612T093000
DTEND;TZID=Europe/Zurich:20250612T094500
DESCRIPTION:10 min talk + 5 min Q&A.
LOCATION:
END:VEVENT
BEGIN:VEVENT
UID:6df04232-e605-40ae-8a0f-4721757c5976
DTSTAMP:20250610T061337Z
SUMMARY:Sinie PhD Outline
DTSTART;TZID=Europe/Zurich:20250612T094500
DTEND;TZID=Europe/Zurich:20250612T100000
DESCRIPTION:10 min talk + 5 min Q&A.
LOCATION:
END:VEVENT
BEGIN:VEVENT
UID:2af85e42-f356-441c-98b2-0f56164841a1
DTSTAMP:20250610T061337Z
SUMMARY:Paper Pitch Presentations – Part 1
DTSTART;TZID=Europe/Zurich:20250612T100000
DTEND;TZID=Europe/Zurich:20250612T105000
DESCRIPTION:4 presenters · 5 min pitch + 7 min discussion each.
LOCATION:
END:VEVENT
BEGIN:VEVENT
UID:89f526e1-aa46-481c-a36d-13e0f6ce831b
DTSTAMP:20250610T061337Z
SUMMARY:Coffee Break
DTSTART;TZID=Europe/Zurich:20250612T105000
DTEND;TZID=Europe/Zurich:20250612T112000
DESCRIPTION:
LOCATION:Lobby Cruna
END:VEVENT
BEGIN:VEVENT
UID:79148ede-daf1-45c2-80ad-18fed6764f52
DTSTAMP:20250610T061337Z
SUMMARY:Paper Pitch Presentations – Part 2
DTSTART;TZID=Europe/Zurich:20250612T112000
DTEND;TZID=Europe/Zurich:20250612T115000
DESCRIPTION:2 presenters · 5 min pitch + 7 min discussion each.
LOCATION:
END:VEVENT
BEGIN:VEVENT
UID:41bf57a9-77ef-4512-bc7b-e6ba6a2fa637
DTSTAMP:20250610T061337Z
SUMMARY:Demo Sessions
DTSTART;TZID=Europe/Zurich:20250612T115000
DTEND;TZID=Europe/Zurich:20250612T121000
DESCRIPTION:Show‑and‑tell of recent projects (~20 min total); volunteers needed.
LOCATION:
END:VEVENT
BEGIN:VEVENT
UID:35b5254c-1e25-470b-98e5-2593ea31c484
DTSTAMP:20250610T061337Z
SUMMARY:Open Discussion: Evolve & Middleware
DTSTART;TZID=Europe/Zurich:20250612T121000
DTEND;TZID=Europe/Zurich:20250612T125000
DESCRIPTION:Moderated by Thilo & Matthias; two 10 min intros + discussion.
LOCATION:
END:VEVENT
BEGIN:VEVENT
UID:de981f31-0d0e-4f7d-a7db-883301ce438e
DTSTAMP:20250610T061337Z
SUMMARY:Lunch
DTSTART;TZID=Europe/Zurich:20250612T125000
DTEND;TZID=Europe/Zurich:20250612T135000
DESCRIPTION:Sandwich Lunch Buffet.
LOCATION:
END:VEVENT
BEGIN:VEVENT
UID:712f1467-a4a2-44b1-a0e9-08d1c24bb870
DTSTAMP:20250610T061337Z
SUMMARY:Walk & Talk (Research Triads)
DTSTART;TZID=Europe/Zurich:20250612T135000
DTEND;TZID=Europe/Zurich:20250612T152000
DESCRIPTION:Pair up and discuss projects while walking, then rotate.
LOCATION:
END:VEVENT
BEGIN:VEVENT
UID:68b8a3c8-eb75-4e66-8103-877b78b431a9
DTSTAMP:20250610T061337Z
SUMMARY:Coffee Break & Check‑in to rooms
DTSTART;TZID=Europe/Zurich:20250612T152000
DTEND;TZID=Europe/Zurich:20250612T161000
DESCRIPTION:
LOCATION:Lobby Cruna
END:VEVENT
BEGIN:VEVENT
UID:da2d18cc-e9f9-4ef7-ae19-aa9822e92552
DTSTAMP:20250610T061337Z
SUMMARY:Lab Culture, Roadmap & Vision
DTSTART;TZID=Europe/Zurich:20250612T161000
DTEND;TZID=Europe/Zurich:20250612T180000
DESCRIPTION:Open exchange and feedback; Miro board for feedback and solutions.
LOCATION:
END:VEVENT
BEGIN:VEVENT
UID:9188b23f-3b24-4d25-80d0-f1754462b812
DTSTAMP:20250610T061337Z
SUMMARY:Dinner & Evening Social
DTSTART;TZID=Europe/Zurich:20250612T180000
DTEND;TZID=Europe/Zurich:20250612T230000
DESCRIPTION:Dinner at the hotel, Pub Quiz, Game Night, "Guess this Viz", Spikeball, PowerPoint Karaoke; volunteers needed.
LOCATION:Hotel Krone / surrounding venues
END:VEVENT
BEGIN:VEVENT
UID:4a9319db-0349-4311-9328-55c4b580cc94
DTSTAMP:20250610T061337Z
SUMMARY:Breakfast
DTSTART;TZID=Europe/Zurich:20250613T073000
DTEND;TZID=Europe/Zurich:20250613T090000
DESCRIPTION:Breakfast buffet.
LOCATION:Hotel Krone
END:VEVENT
BEGIN:VEVENT
UID:234b56cc-3fdc-42f3-b3e7-e784d4070a05
DTSTAMP:20250610T061337Z
SUMMARY:Arrival & Setup
DTSTART;TZID=Europe/Zurich:20250613T090000
DTEND;TZID=Europe/Zurich:20250613T091500
DESCRIPTION:Everyone checking out of rooms and leaving luggage in storage room.
LOCATION:
END:VEVENT
BEGIN:VEVENT
UID:d8a59262-6db0-4be9-b798-97ad9aae9ee1
DTSTAMP:20250610T061337Z
SUMMARY:Welcome & Agenda Overview
DTSTART;TZID=Europe/Zurich:20250613T091500
DTEND;TZID=Europe/Zurich:20250613T093000
DESCRIPTION:
LOCATION:Menna
END:VEVENT
BEGIN:VEVENT
UID:aaaa03ff-4be4-4645-a7b0-66e34ddaf658
DTSTAMP:20250610T061337Z
SUMMARY:Panel Discussion
DTSTART;TZID=Europe/Zurich:20250613T093000
DTEND;TZID=Europe/Zurich:20250613T104500
DESCRIPTION:Topic TBD; potential PhD‑led panel—looking for volunteers.
LOCATION:
END:VEVENT
BEGIN:VEVENT
UID:d54f2a16-5bd4-4cc0-8dc2-a9da170bc23c
DTSTAMP:20250610T061337Z
SUMMARY:Coffee Break
DTSTART;TZID=Europe/Zurich:20250613T104500
DTEND;TZID=Europe/Zurich:20250613T111500
DESCRIPTION:
LOCATION:Lobby Cruna
END:VEVENT
BEGIN:VEVENT
UID:ab6cc040-150e-4c1d-bd77-298cf07700b5
DTSTAMP:20250610T061337Z
SUMMARY:Skills & Tools
DTSTART;TZID=Europe/Zurich:20250613T111500
DTEND;TZID=Europe/Zurich:20250613T124500
DESCRIPTION:Paper websites (Cursor) • Best practices in full‑stack development.
LOCATION:
END:VEVENT
BEGIN:VEVENT
UID:a94076a3-7c12-4a9b-bda5-9a24355af7d2
DTSTAMP:20250610T061337Z
SUMMARY:Lunch
DTSTART;TZID=Europe/Zurich:20250613T124500
DTEND;TZID=Europe/Zurich:20250613T134500
DESCRIPTION:Sandwich Lunch Buffet.
LOCATION:
END:VEVENT
BEGIN:VEVENT
UID:8d7df834-4cd9-4495-a63e-dd6f4a29d6e1
DTSTAMP:20250610T061337Z
SUMMARY:Breakout Groups
DTSTART;TZID=Europe/Zurich:20250613T134500
DTEND;TZID=Europe/Zurich:20250613T151500
DESCRIPTION:1. Failure Fest  · 2. Mini‑Hackathon · 3. Collaborative Session · 4. Open Research Brainstorming.
LOCATION:
END:VEVENT
BEGIN:VEVENT
UID:8e41a8db-4621-4df7-ba0b-3bf3523ceb48
DTSTAMP:20250610T061337Z
SUMMARY:Coffee Break
DTSTART;TZID=Europe/Zurich:20250613T151500
DTEND;TZID=Europe/Zurich:20250613T154500
DESCRIPTION:
LOCATION:Lobby Cruna
END:VEVENT
BEGIN:VEVENT
UID:f783dc7c-7c8a-45a4-afa4-573a07f5bdd9
DTSTAMP:20250610T061337Z
SUMMARY:Continuation Breakout Groups
DTSTART;TZID=Europe/Zurich:20250613T154500
DTEND;TZID=Europe/Zurich:20250613T171500
DESCRIPTION:
LOCATION:
END:VEVENT
BEGIN:VEVENT
UID:26571b0a-3ec8-4500-970b-4bd370963906
DTSTAMP:20250610T061337Z
SUMMARY:Closing Reflections + Two Truths & a Lie
DTSTART;TZID=Europe/Zurich:20250613T171500
DTEND;TZID=Europe/Zurich:20250613T174500
DESCRIPTION:High‑impact directions for the lab – Science edition.
LOCATION:
END:VEVENT
BEGIN:VEVENT
UID:3e57ff3f-8430-4ad2-a395-97e4206b6a6c
DTSTAMP:20250610T061337Z
SUMMARY:Departure by bus from Churwalden
DTSTART;TZID=Europe/Zurich:20250613T183600
DTEND;TZID=Europe/Zurich:20250613T202200
DESCRIPTION:Leaving 18:15 (+5 min walk from hotel).
LOCATION:Churwalden, Bergbahnen
END:VEVENT
BEGIN:VEVENT
UID:a777fa30-accd-49d9-9b96-70bfa707dc45
DTSTAMP:20250610T061337Z
SUMMARY:Arrival at Zurich HB
DTSTART;TZID=Europe/Zurich:20250613T202200
DTEND;TZID=Europe/Zurich:20250613T202700
DESCRIPTION:
LOCATION:Zurich HB
END:VEVENT
END:VCALENDAR`;
